module.exports = __webpack_public_path__ + "img/events-and-entertainment-02.a2be30a7.jpg";